import Slider from '../Slider/Slider';

const selector = '.elementcarousel .splide';

export function ImageCarousel(scope = document) {
  scope.querySelectorAll(selector).forEach((el) => {
    Slider(el, {
      perMove: 1,
      type: 'loop',
      autoplay: false,
      interval: 5000,
      pauseOnHover: true,
      pauseOnFocus: true,
      focus: 'center',
    });
  });
}

export default function init(scope = document) {
  if (scope.querySelector(selector)) {
    ImageCarousel(scope);
  }
}
